import React, { useEffect, useState } from 'react'
import { Avatar, Menu, Text } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import "./CSS/navbarTop.css"
import client from '../../API/API';
import axios from 'axios';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { logInStatus } from '../../Store/store';
import Cookies from 'js-cookie'


const Logout = () =>
{

    const navigate = useNavigate()
    const [logout, setLogout] = useState(false)

   const handleLogout = async () => {
  try {
    const refresh = localStorage.getItem("refresh_token");

    await client.post("/api/logout/", {
      refresh: refresh,
    });

  } catch (error) {
    console.log("Logout error", error);
  } finally {
    // 🔥 clear everything no matter what
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("username");
    localStorage.removeItem("userid");

    navigate("/login");
    // window.location.reload();
  }
};

    // useEffect(() =>
    // {
    //     if (logout)
    //     {
    //         window.location.reload('/login')
    //     }

    // }, [logout])
    const username = window.localStorage.getItem('username') || '';

    return (
        // <Container >
        <Menu withArrow arrowPosition='center' position='bottom-end'>
            <Menu.Target>
                <Avatar color="var(--color-icon)" radius="xl"><Text size={20} > {username ? username.charAt(0).toUpperCase() : ''}</Text></Avatar>
            </Menu.Target>
            <Menu.Dropdown sx={{ marginTop: '1.2rem' }} >
                <Menu.Item sx={{ fontSize: '16px' }} pr={60} fw={500} color='var(--color-bold-text)'>{username
  ? username.charAt(0).toUpperCase() + username.slice(1)
  : ''}</Menu.Item>
                {/* <Menu.Label>Role</Menu.Label> */}
                <Menu.Divider />
                {/* <Menu.Item sx={{ fontSize: '16px' }} fw={500} color='var(--color-text)'><Link to={'/settings'} style={{ textDecoration: 'none', color: 'var(--color-text)' }}>Account Settings</Link> </Menu.Item> */}
                <Menu.Item fw={500} color='rgba(211, 40, 40, 1)' sx={{ fontSize: '16px' }} onClick={handleLogout}>Logout</Menu.Item>
            </Menu.Dropdown>
        </Menu>


        // </Container>
    )
}

export default Logout
